import { View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { tableStyles } from '../Table/tableStyles.js';

type Props = PropsWithChildren<{ wrap?: boolean }>;

export function Tr({ wrap, children }: Props) {
  return (
    <View style={tableStyles.tr} wrap={wrap}>
      {children}
    </View>
  );
}
